import Header from '../components/layout/Header'
import Hero from '../components/layout/Hero'
import About from '../components/shared/About'
import Courses from '../components/features/courses/Courses'
import Gallery from '../components/features/gallery/Gallery'
import Instructors from '../components/shared/Instructors'
import Testimonials from '../components/shared/Testimonials'
import Contact from '../components/shared/Contact'
import SEOHead from '../components/seo/SEOHead'
import AIOptimizedContent from '../components/seo/AIOptimizedContent'
import GeoSEO from '../components/seo/GeoSEO'

export default function Home() {
  return (
    <main className="bg-[#FDFBF7] overflow-x-hidden">
      <SEOHead 
        title="Home"
        description="Sudha's Academy - India's premier beauty and makeup training institute since 2006. Learn professional bridal makeup, skincare, hair styling, and cosmetology from Dr. Sudha M. Join 15,000+ successful graduates."
        keywords="Sudha's Academy, best makeup academy India, bridal makeup course Chennai, professional beauty training, cosmetology diploma, hair styling classes, skincare certification, Dr Sudha M"
        url="https://sudhasacademy.com/"
        breadcrumbs={[
          { name: 'Home', url: '/' }
        ]}
      />
      <AIOptimizedContent pageType="home" />
      <GeoSEO />
      <Header />
      <Hero />
      <About />
      <Courses />
      <Gallery />
      <Instructors />
      <Testimonials />
      <Contact />
    </main>
  )
}
